"use strict";

exports.__esModule = true;
exports.fetchByStation = exports.fetchByGps = void 0;

var util_1 = require("../../util");

var validation_1 = require("./validation");

var RESULT_LIMIT = 10;
var BASE_LATEST_URL = "https://api.openaq.org/v1/latest";
var BASE_MEASUREMENTS_URL = "https://api.openaq.org/v1/measurements";

function additionalOptions(options) {
  if (options === void 0) {
    options = {};
  }

  var query = ''; // dateFrom

  if (options.dateFrom) {
    query += "&date_from=" + options.dateFrom.toISOString();
  } // dateTo


  if (options.dateTo) {
    query += "&date_to=" + options.dateTo.toISOString();
  } // includeFields


  query += "&include_fields=" + (options.includeFields || ['attribution', 'averagingPeriod', 'mobile', 'sourceName', 'sourceType']).join(','); // limit

  query += "&limit=" + (options.limit || RESULT_LIMIT); // parameter

  query += (options.parameter || []).map(function (p) {
    return "&parameter[]=" + p;
  }).join('');
  return query;
}
/**
 * Handle error from OpenAQ response
 */


function onError(error) {
  var _a; // We had occasions from OpenAQ where the error had an empty response field


  if ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) {
    return new Error(error.response.data.statusCode + " " + error.response.data.error + ": " + error.response.data.message);
  }

  return new Error(JSON.stringify(error));
}
/**
 * Fetch the closest station to the user's current position
 *
 * @param gps - Latitude and longitude of the user's current position
 */


function fetchByGps(gps, options) {
  var latitude = gps.latitude,
      longitude = gps.longitude;
  return util_1.fetchAndDecode(BASE_LATEST_URL + "?coordinates=" + latitude + "," + longitude + "&radius=" + util_1.ACCURATE_RADIUS + additionalOptions(options), validation_1.OpenAQLatestCodec, {
    onError: onError
  });
}

exports.fetchByGps = fetchByGps;
/**
 * Fetch data by station
 *
 * @param stationId - The station ID to search
 */

function fetchByStation(stationId, options) {
  return util_1.fetchAndDecode(BASE_MEASUREMENTS_URL + "?location=" + stationId + additionalOptions(options), validation_1.OpenAQMeasurementsCodec, {
    onError: onError
  });
}

exports.fetchByStation = fetchByStation;